import React, { useEffect } from "react";
import { Box, Typography, Card, CircularProgress } from "@mui/joy";
import { connect, useDispatch } from "react-redux";
import { viewLogRequest, viewLogReset } from "../../../store/actions";
import { STATUS } from "../../../constant";
import { toast } from "react-toastify";

const ViewLog = ({
  selectedLog,
  logModal,

  viewLogStatus,
  viewLogMessage,
  viewLogResult,

  otpResult,
}) => {
  const dispatch = useDispatch();
  const token = otpResult?.token;
  const logContent = viewLogResult?.content;

  useEffect(() => {
    if (selectedLog) {
      dispatch(viewLogRequest(token, selectedLog));
    }

    return () => {
      dispatch(viewLogReset());
    };
  }, [logModal]);

  useEffect(() => {
    if (viewLogStatus === STATUS.ERROR) {
      toast.error(viewLogMessage, {
        toastId: "viewLogError",
      });
      dispatch(viewLogReset());
    }
  }, [dispatch, viewLogMessage, viewLogStatus]);

  const lines = logContent
    ? Object.keys(logContent).map((key) => `${key}: ${logContent[key]}`)
    : [];

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          p: 2,
          mt: 3,
          backgroundColor: "#fefae0",
          borderRadius: 2,
          maxHeight: "60vh",
          overflowY: "auto",
          overflowX: "auto",
          whiteSpace: "pre",
          fontFamily: '"Roboto Mono", monospace',
          fontSize: "14px",
          lineHeight: 1.6,
        }}
      >
        <Box>
          {viewLogStatus === STATUS.LOADING ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "40vh",
              }}
            >
              <CircularProgress
                size="lg"
                variant="soft"
                sx={{
                  "--CircularProgress-size": "70px",
                  "--CircularProgress-trackThickness": "2px",
                  "--CircularProgress-progressThickness": "4px",
                }}
              />
            </Box>
          ) : (
            <>
              {lines?.map((line, index) => (
                <Typography
                  key={index}
                  sx={{
                    whiteSpace: "pre-wrap",
                    fontFamily: '"Roboto Mono", monospace',
                    mb: 0.5,
                    fontSize: "12px",
                  }}
                >
                  {line || "\u00A0"}
                </Typography>
              ))}
            </>
          )}
        </Box>
      </Card>
    </>
  );
};

const mapStateToProps = ({ auth, logs }) => {
  const { viewLogStatus, viewLogMessage, viewLogResult } = logs;
  const { otpResult } = auth;

  return {
    viewLogStatus,
    viewLogMessage,
    viewLogResult,
    otpResult,
  };
};

export default connect(mapStateToProps, {})(ViewLog);
